"use client";

import React from "react";
import { IconButton } from '../IconButton';
import type { IconButtonProps } from '../IconButton';

const CloseButton = (props: Omit<IconButtonProps, 'iconType' | 'size' | 'variant' | 'hoverColor' | 'borderColor' | 'active'>) => {
  return (
    <IconButton iconType="x" size="md" variant="plain" name="Close" {...props} />
  );
};

export default CloseButton;
